/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyV2ExecuteResponse {
    getFixupPrototypeFunction() { return PolicyV2ExecuteResponse.fixupPrototype; }

    static newInstance(model: Partial<PolicyV2ExecuteResponse>): PolicyV2ExecuteResponse {
        let obj = Object.assign(new PolicyV2ExecuteResponse(), model);
        PolicyV2ExecuteResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyV2ExecuteResponse>): PolicyV2ExecuteResponse {
        if (!model) return null;
        return PolicyV2ExecuteResponse.newInstance(<PolicyV2ExecuteResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyV2ExecuteResponse) {
        if (!obj) return;

        models.PolicyV2ExecuteResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyV2ExecuteResponse): boolean {
        Object.setPrototypeOf(obj, PolicyV2ExecuteResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
    }

    /**
     * Unique identifier of the execution job
     */
    job_id: string;

    /**
     * Job creation time in UTC
     */
    created_at: Date;

}
